export const FETCH_COMPANY_JOB_REQUEST = 'FETCH_COMPANY_JOB_REQUEST';
export const FETCH_COMPANY_JOB_SUCCESS = 'FETCH_COMPANY_JOB_SUCCESS';
export const FETCH_COMPANY_JOB_FAIL = 'FETCH_COMPANY_JOB_FAIL';

export const FETCH_COMPANY_JOB_INVOICE_DOCUMENT_REQUEST =
  'FETCH_COMPANY_JOB_INVOICE_DOCUMENT_REQUEST';
export const FETCH_COMPANY_JOB_INVOICE_DOCUMENT_SUCCESS =
  'FETCH_COMPANY_JOB_INVOICE_DOCUMENT_SUCCESS';
export const FETCH_COMPANY_JOB_INVOICE_DOCUMENT_FAIL =
  'FETCH_COMPANY_JOB_INVOICE_DOCUMENT_FAIL';

export const FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_REQUEST =
  'FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_REQUEST';
export const FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_SUCCESS =
  'FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_SUCCESS';
export const FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_FAIL =
  'FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_FAIL';

export const FETCH_COMPANY_JOB_W9_DOCUMENT_REQUEST =
  'FETCH_COMPANY_JOB_W9_DOCUMENT_REQUEST';
export const FETCH_COMPANY_JOB_W9_DOCUMENT_SUCCESS =
  'FETCH_COMPANY_JOB_W9_DOCUMENT_SUCCESS';
export const FETCH_COMPANY_JOB_W9_DOCUMENT_FAIL =
  'FETCH_COMPANY_JOB_W9_DOCUMENT_FAIL';

export const FETCH_DOWNLOAD_ALL_W9_AS_ZIP_REQUEST =
  'FETCH_DOWNLOAD_ALL_W9_AS_ZIP_REQUEST';
export const FETCH_DOWNLOAD_ALL_W9_AS_ZIP_SUCCESS =
  'FETCH_DOWNLOAD_ALL_W9_AS_ZIP_SUCCESS';
export const FETCH_DOWNLOAD_ALL_W9_AS_ZIP_FAIL =
  'FETCH_DOWNLOAD_ALL_W9_AS_ZIP_FAIL';

export const FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_REQUEST =
  'FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_REQUEST';
export const FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_SUCCESS =
  'FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_SUCCESS';
export const FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_FAIL =
  'FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_FAIL';

export const FETCH_DOWNLOAD_ALL_PROOF_OF_PAYMENT_AS_ZIP_REQUEST =
  'FETCH_DOWNLOAD_ALL_PROOF_OF_PAYMENT_AS_ZIP_REQUEST';
export const FETCH_DOWNLOAD_ALL_PROOF_OF_PAYMENT_AS_ZIP_SUCCESS =
  'FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_SUCCESS';
export const FETCH_DOWNLOAD_ALL_PROOF_OF_PAYMENT_AS_ZIP_FAIL =
  'FETCH_DOWNLOAD_ALL_PROOF_OF_PAYMENT_AS_ZIP_FAIL';

export const FETCH_DOWNLOAD_ALL_AS_ZIP_REQUEST =
  'FETCH_DOWNLOAD_ALL_AS_ZIP_REQUEST';
export const FETCH_DOWNLOAD_ALL_AS_ZIP_SUCCESS =
  'FETCH_DOWNLOAD_ALL_AS_ZIP_SUCCESS';
export const FETCH_DOWNLOAD_ALL_AS_ZIP_FAIL = 'FETCH_DOWNLOAD_ALL_AS_ZIP_FAIL';

export const FETCH_DOWNLOAD_INVOICE_REQUEST = 'FETCH_DOWNLOAD_INVOICE_REQUEST';
export const FETCH_DOWNLOAD_INVOICE_SUCCESS = 'FETCH_DOWNLOAD_INVOICE_SUCCESS';
export const FETCH_DOWNLOAD_INVOICE_FAIL = 'FETCH_DOWNLOAD_INVOICE_FAIL';

export const FETCH_DOWNLOAD_PROOF_OF_PAYMENT_REQUEST = 'FETCH_DOWNLOAD_PROOF_OF_PAYMENT_REQUEST';
export const FETCH_DOWNLOAD_PROOF_OF_PAYMENT_SUCCESS = 'FETCH_DOWNLOAD_PROOF_OF_PAYMENT_SUCCESS';
export const FETCH_DOWNLOAD_PROOF_OF_PAYMENT_FAIL = 'FETCH_DOWNLOAD_PROOF_OF_PAYMENT_FAIL';

export const FETCH_DOWNLOAD_REPORTS_REQUEST = 'FETCH_DOWNLOAD_REPORTS_REQUEST';
export const FETCH_DOWNLOAD_REPORTS_SUCCESS = 'FETCH_DOWNLOAD_REPORTS_SUCCESS';
export const FETCH_DOWNLOAD_REPORTS_FAIL = 'FETCH_DOWNLOAD_REPORTS_FAIL';

export const FETCH_DOWNLOAD_ARCHIVE_REQUEST = 'FETCH_DOWNLOAD_ARCHIVE_REQUEST';
export const FETCH_DOWNLOAD_ARCHIVE_REQUEST_SUCCESS = 'FETCH_DOWNLOAD_ARCHIVE_REQUEST_SUCCESS';
export const FETCH_DOWNLOAD_ARCHIVE_REQUEST_FAIL = 'FETCH_DOWNLOAD_ARCHIVE_REQUEST_FAIL';